import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, PopoverController, Platform } from '@ionic/angular';

import { InitConstant, DialogConstant } from '../../Constant';

import { AuthService } from '../../service/auth.service';
import { EventService } from '../../service/event.service';

import { PreviewModalPage } from '../preview-modal/preview-modal.page';

@Component({
    selector: 'app-trashmenu-popover',
    templateUrl: './trashmenu-popover.page.html',
    styleUrls: ['./trashmenu-popover.page.scss'],
})
export class TrashmenuPopoverPage
{
    private resize = null;
    private obj: any;
    private file: any;
    private list_viewtype = 'list-block';
    private filemenu_modal = null;

    constructor(
        private nav: NavController,
        private modalCtrl: ModalController,
        private popover: PopoverController,
        private navParams: NavParams,
        private platform: Platform,
        private auth: AuthService,
        private event: EventService
    )
    {
    }

    async ngOnInit()
    {
        this.resize = this.platform.resize.subscribe(() => {
            this.popover.dismiss();
        });

        this.obj = this.navParams.data.obj;
        this.file = this.navParams.data.file;
        this.list_viewtype = this.navParams.data.list_viewtype;
    }

    ngOnDestroy()
    {
        if (this.resize == null) return;
        this.resize.unsubscribe();
        this.resize = null;
    }
}
